import { render, staticRenderFns } from "./login-popup.vue?vue&type=template&id=0d8e11fa"
import script from "./login-popup.vue?vue&type=script&lang=js"
export * from "./login-popup.vue?vue&type=script&lang=js"
import style0 from "./login-popup.vue?vue&type=style&index=0&id=0d8e11fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports